let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dhApK")).then(() => parcelRequire('4f7n4'));